const React = require('react');
const PersonFields = require('../PersonFields');
const {AdminSwitch} = require('../../../../FormInputs');

module.exports = ({activeUserId, formCtx}) => {
  return (
    <PersonFields
      prefix="account_holder"
      title="Account Holder"
      activeUserId={activeUserId}
      formCtx={formCtx}
      lastField={(
        <AdminSwitch
          label="I'm a Director"
          name="holder_is_director"
          className="mt39"
          formCtx={formCtx}
        />
      )}
    />
  );
};
